import React from 'react';
 
const CalculateWidget = ({ field, value }) => {
  const isEmpty = value === null || value === undefined || value === '';
  const placeholder = field?.placeholder || 'Calculating...';

  return (
    <div className={`w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium select-none transition-all duration-200 ${
      isEmpty ? 'text-gray-400' : 'text-gray-800'
    }`}>
      <div className="flex items-center justify-between">
        <span className="truncate">
          {isEmpty ? placeholder : String(value)}
        </span>
        <div className="flex items-center gap-1.5 px-2 py-0.5 rounded bg-blue-50 border border-blue-100 text-[10px] font-bold text-blue-600 uppercase tracking-tight shrink-0">
          <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
          Computed
        </div>
      </div>
    </div>
  );
};

export default CalculateWidget;
